:host{display:flex;width:100%;align-items:center;font-family:Maison Neue,sans-serif}:host .grid-layout{display:grid;gap:10px;width:100%}:host .label-text{color:#232426;opacity:.6}:host .submitters{display:flex}:host .submitter-name{margin-left:auto}
/*# sourceMappingURL=submitter-info.component.css.map */
